// extracted by mini-css-extract-plugin
module.exports = {"address":"_3Gc7uvzE7-81Cb1ZZbb57A"};